import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {openInBrowser} from '../../../../../../srcCommon/browser/openInBrowser';
import {useAppSelector} from '../../../../../helpers/reduxHelpers';
import {getCompanyHost} from '../../../../../store/data/company/companySelectors';

/*
 * Props.
 */

/*
 * Component.
 */

export const FrontLinksTargetButton: FC = (props) => {
  const host = useAppSelector(getCompanyHost);

  return (
    <Button
      variant={ButtonVariantsEnum.SECONDARY}
      size={VisualSizesEnum.MEDIUM}
      onClick={() => openInBrowser(`${host}/open/where`)}
    >
      <Trans id="front-links-target-button">Set target</Trans>
    </Button>
  );
};
